import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { storeCreator } from "./app/store";
import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";
import { v4 as uuid } from "uuid";

import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

import { BrowserRouter as Router } from "react-router-dom";


const queryParameters = new URLSearchParams(window.location.search);
let channel = queryParameters.get("channel"); // for react sync
if (channel === null || channel === undefined) {
  // we define it randomly
  channel = uuid();
}
window.orthophoto_bc_channel = channel;

ReactDOM.render(
  <React.StrictMode>
    <Provider store={storeCreator({ channel })}>
      <Router>
        <App />
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
